import $ from 'jquery';
import whatInput from 'what-input';

//import 'customizer';
import 'navigation';

window.$ = $;

import Foundation from 'foundation-sites';
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

$(document).foundation();

$(document).ready(function(){
	$('#nav-icon').click(function(){
		$('#nav-icon').toggleClass('open');
		revealOverlay();
	});


 // ScrollReveal //

	ScrollReveal().reveal('.wp-block-group', {
    duration: 750,
      distance: "40px",
      easing: "cubic-bezier(0.5, -0.01, 0, 1.005)",
      interval: 64,
      origin: "bottom",
      viewFactor: 0.32,
      delay: 100
	}); 

});

var lightbox = GLightbox({
  selector: '.wp-block-gallery a img, .wp-block-image a img',
  touchNavigation: true

});

//////////////////////////////
// Reveal menu with revealOverlay()
//////////////////////////////

function revealOverlay() {
  document.getElementById("overlayMenu").classList.toggle("overlay-reveal");
  document.body.classList.toggle('menu-open');
}




